import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";
import { getCollectionYardWasteTypeRates } from "./collectionYard";

export const getVisitEdit = (state: RootState) => state.visitEdit;
export const getVisitEditVisitId = (state: RootState) => state.visitEdit.visitId;
export const getVisitEditPlateNumber = (state: RootState) => state.visitEdit.plateNumber;

export const getVisitEditVisitEventsStatus = (state: RootState) => state.visitEdit.status;
export const getVisitEditVisitEventsErrorMSg = (state: RootState) => state.visitEdit.errorMsg;

export const getVisitEditEvents = (state: RootState) => state.visitEdit.events;
export const getVisitEditRemovedEventsIds = (state: RootState) => state.visitEdit.removedEventsIds;

export const getVisitEditEventsWasteTypesIds = createSelector([getVisitEditEvents], (events) => {
  return events.map((event) => event.wasteTypeId);
});

export const getVisitEditIsTouched = (state: RootState) => state.visitEdit.isTouched;

export const getVisitEditCanSave = createSelector([getVisitEditEvents, getVisitEditIsTouched], (events, isTouched) => {
  if (!isTouched) return false;

  const notInUnfinishedEvents = events.filter((event) => !event.unfinished);
  return notInUnfinishedEvents.every((event) => Number(event.brutto) >= Number(event.tara));
});

export const getWasteTypeGroupedEvents = createSelector([getVisitEditEvents], (events) => {
  // Sort by waste type from oldest to newest. (ascending)
  const wasteTypesIdsAscending = Array.from(new Set(events.map((event) => event.wasteTypeId)));
  // In UI we need show newest events first. (descending)
  const wasteTypesIdsDescending = wasteTypesIdsAscending.reverse();

  const groupedEvents = events.reduce((acc: { [key: number]: typeof events }, event) => {
    if (!acc[event.wasteTypeId]) {
      acc[event.wasteTypeId] = [];
    }

    acc[event.wasteTypeId].push(event);

    return acc;
  }, {});

  return wasteTypesIdsDescending.map((wasteTypeId) => groupedEvents[wasteTypeId] || []);
});

export const getVisitEditTotalPriceForFinishedEvents = createSelector(
  [getVisitEditEvents, getCollectionYardWasteTypeRates],
  (events, wasteTypeRates) => {
    return events.reduce((acc, event) => {
      if (event.unfinished) return acc;

      const wasteTypeRate = wasteTypeRates[event.wasteTypeId];
      const netto = Number(event.brutto) - Number(event.tara);
      return acc + (wasteTypeRate ? wasteTypeRate * netto : 0);
    }, 0);
  }
);
